export default class CommonDataProtection {
  /** (Boolean): Consentimiento a la política de privacidad. */
  // privacyPolicyConsent!: boolean

  // /** (Boolean): Consentimiento para recibir noticias de Asisa. */
  // asisaNewsConsent!: boolean

  /** (Boolean): Consentimiento para la transferencia de datos. */
  dataTransfer!: boolean

  /** (Boolean): Consentimiento para la publicidad telefónica de terceros. */
  thirdPartyTelephoneAdvertising!: boolean

  /** (Boolean): Consentimiento para la publicidad escrita de terceros. */
  thirdPartyWrittenAdvertising!: boolean

  constructor(data: any) {
    // this.privacyPolicyConsent = data.privacyPolicyConsent
    // this.asisaNewsConsent = data.asisaNewsConsent
    this.dataTransfer = data.dataTransfer
    this.thirdPartyTelephoneAdvertising = data.thirdPartyTelephoneAdvertising
    this.thirdPartyWrittenAdvertising = data.thirdPartyWrittenAdvertising
  }
}
